import { PhoneInput } from "@/components/app-ui/phone-input";
import { FieldPath, FieldValues } from "react-hook-form";
import { FormFieldBase, FormFieldCommonProps } from "./form-field-base";

type PhoneInputFormFieldProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = FormFieldCommonProps<TFieldValues, TName> & {
    placeholder?: string;
};

export function PhoneInputFormField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ placeholder, ...props }: PhoneInputFormFieldProps<TFieldValues, TName>) {
    return (
        <FormFieldBase
            {...props}
            renderField={(field, fieldState, disabled) => (
                <PhoneInput
                    placeholder={placeholder}
                    defaultCountry="TR"
                    value={field.value}
                    onChange={field.onChange}
                    disabled={disabled}
                />
            )}
        />
    );
}
